module.exports = __webpack_public_path__ + "assets/img/ef8d-gb-nir.svg";